module.exports = __webpack_public_path__ + "assets/img/img324.fdc01228.png";